module.exports = __webpack_public_path__ + "img/drag-and-drop-default.4d70b999.svg";